import { Component, OnInit, ViewChild, Input } from '@angular/core';

import { ScoringComponent }       from '../scoring/scoring.component';

@Component({
  selector: 'app-fractions-extend',
  template: `
    <p>
      fractions-extend works!
    </p>

    <p>{{scoreCount}}</p>

    <p><app-scoring #score></app-scoring></p>

    <button mat-raised-button (click)="increment()"><b>Begynd</b></button>
    <button mat-raised-button (click)="score.correct()"><b>Correct</b></button>  
  `,
  // templateUrl: './fractions-extend.component.html',
  styleUrls: ['./fractions-extend.component.css']
})

export class FractionsExtendComponent implements OnInit {
  scoreCount: number;
  @Input() mlevel: number; 
  @ViewChild('score') score;
//  score: ScoringComponent;

  constructor() { 
    
  }

  ngOnInit() {
    this.scoreCount = 0;
  }

  increment(){
    this.scoreCount++;
    this.score.correct();
  }

  setLevel(level: number)
  {
    this.mlevel = level;
  }

}



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/fractions-extend/fractions-extend.component.ts